import React, { ReactNode } from 'react';
import { useHardwareBackButton } from '../hooks';

interface AppNavigationWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper component that enables global navigation features
 * like hardware back button handling on Android
 */
const AppNavigationWrapper: React.FC<AppNavigationWrapperProps> = ({ children }) => {
  // Enable hardware back button handling globally
  useHardwareBackButton({
    enabled: true,
    exitOnRoot: true
  });

  return <>{children}</>;
};

export default AppNavigationWrapper;